export const INITIAL_BALANCE_REQUEST = "INITIAL_BALANCE_REQUEST";
export const FINAL_BALANCE_REQUEST = "FINAL_BALANCE_REQUEST";

export const FETCH_BALANCE_SUCCESS = "FETCH_BALANCE_SUCCESS";
export const FETCH_BALANCE_ERROR = "FETCH_BALANCE_ERROR";

export const DELETE_BALANCE_SUCCESS = "DELETE_BALANCE_SUCCESS";
export const SAVE_BALANCE_SUCCESS = "SAVE_BALANCE_SUCCESS";
